var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.3076 3.49051H37.0706L24.4801 18.9336L39.2918 39.9481H27.6944L18.6108 27.2029L8.21716 39.9481H2.45065L15.9174 23.43L1.7085 3.49051H13.6004L21.8111 15.1401L31.3076 3.49051ZM29.2849 36.2463H32.4783L11.8652 6.99792H8.43841L29.2849 36.2463Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.286ba5971b7fffb13c773ed893cc1ffc.svg";
export { ForwardRef as ReactComponent };